export const PAGE_CONFIG = {
  title: 'Ad Funnel',
  titleCN: '广告漏斗',
  subTitle: '',
  subTitleCN: '',
  showTimeZone: false,
  path: '/monetization/adFunnel',
  defaultTab: 'ad_funnel',
  tabList: [
    {
      id: 'ad_funnel',
      tabName: 'Ad Funnel',
      tabNameCN: '广告漏斗',
      isHaveNotification: true,
      notificationPath: '/monetization/adFunnel',
      path: '/monetization/adFunnel',
      logConfig: {
        pageId: '209101',
        pageName: 'Ad Funnel',
        extInfo: '',
        pagePath: '/monetization/adFunnel',
      },
      filters: [
        {
          name: 'PcConsoleDailyFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/monetization/adFunnel',
          timeZone: '-4',
          componentList: [
            {
              name: 'MetricInfo',
              children: [
                {
                  name: 'KeyMetricsCo',
                  className: '',
                  type: 'view',
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/overview_daily/card_metrics',
                      mainMetricsList: [
                        'funnel_sdk_init_succ_rate_per',
                        'funnel_banner_imps_per_launch',
                      ],
                      metricsList: [
                        'funnel_sdk_init_succ_rate_per',
                        'funnel_banner_imps_per_launch',
                      ],
                      haveJump: false,
                      loadingHeight: 200,
                      otherParams: { logical_flag: 'ad_format_all' },
                    },
                  },
                  children: [
                    {
                      name: 'CommonRow',
                      className: 'margin-t-10',
                      children: [
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 12 },
                          children: [
                            {
                              name: 'MetricCard',
                              type: 'view',
                              props: {
                                config: {
                                  componentMetrics: [
                                    {
                                      icon: 'pie-chart-icon',
                                      metricKey:
                                        'funnel_sdk_init_succ_rate_per',
                                      enName:
                                        '{{metricsInfo.funnel_sdk_init_succ_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_sdk_init_succ_rate_per.cn}}',
                                      explainEn:
                                        '{{metricsInfo.funnel_sdk_init_succ_rate_per.explainEn}}',
                                      explainCn:
                                        '{{metricsInfo.funnel_sdk_init_succ_rate_per.explainCn}}',
                                      formatRule:
                                        '{{metricsInfo.funnel_sdk_init_succ_rate_per.formatter}}',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 12 },
                          children: [
                            {
                              name: 'MetricCard',
                              type: 'view',
                              props: {
                                config: {
                                  componentMetrics: [
                                    {
                                      icon: 'pie-chart-icon',
                                      metricKey:
                                        'funnel_banner_imps_per_launch',
                                      enName:
                                        '{{metricsInfo.funnel_banner_imps_per_launch.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_banner_imps_per_launch.cn}}',
                                      explainEn:
                                        '{{metricsInfo.funnel_banner_imps_per_launch.explainEn}}',
                                      explainCn:
                                        '{{metricsInfo.funnel_banner_imps_per_launch.explainCn}}',
                                      formatRule:
                                        '{{metricsInfo.funnel_banner_imps_per_launch.formatter}}',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'KeyMetricsCo',
                  className: '',
                  type: 'view',
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/overview_daily/card_metrics',
                      mainMetricsList: [
                        'funnel_ready_rate_per',
                        'funnel_interstitial_opps_per_round',
                        'funnel_impression_per_level',
                      ],
                      metricsList: [
                        'funnel_ready_rate_per',
                        'funnel_interstitial_opps_per_round',
                        'funnel_impression_per_level',
                      ],
                      haveJump: false,
                      loadingHeight: 200,
                      otherParams(data: any) {
                        const existingCustomFilters =
                          data?.custom_filters || [];
                        const adFormatFilter = existingCustomFilters.find(
                          (item: any) => item.key === 'ad_format',
                        );
                        if (adFormatFilter) {
                          adFormatFilter.filter_list = ['interstitial'];
                        } else {
                          existingCustomFilters.push({
                            key: 'ad_format',
                            filter_list: ['interstitial'],
                          });
                        }
                        return {
                          logical_flag: 'ad_format_all',
                          filters: Object.assign({}, data, {
                            custom_filters: existingCustomFilters,
                          }),
                        };
                      },
                    },
                  },
                  children: [
                    {
                      name: 'CommonRow',
                      className: 'margin-t-10',
                      children: [
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 8 },
                          children: [
                            {
                              name: 'MetricCard',
                              type: 'view',
                              props: {
                                config: {
                                  isLeftCard: true,
                                  componentMetrics: [
                                    {
                                      icon: 'pie-chart-icon',
                                      metricKey: 'funnel_ready_rate_per',
                                      enName:
                                        '{{metricsInfo.funnel_ready_rate_per_interstitial.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_ready_rate_per_interstitial.cn}}',
                                      explainEn:
                                        '{{metricsInfo.funnel_ready_rate_per_interstitial.explainEn}}',
                                      explainCn:
                                        '{{metricsInfo.funnel_ready_rate_per_interstitial.explainCn}}',
                                      formatRule:
                                        '{{metricsInfo.funnel_ready_rate_per_interstitial.formatter}}',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 8 },
                          children: [
                            {
                              name: 'MetricCard',
                              type: 'view',
                              props: {
                                config: {
                                  componentMetrics: [
                                    {
                                      icon: 'pie-chart-icon',
                                      metricKey:
                                        'funnel_interstitial_opps_per_round',
                                      enName:
                                        '{{metricsInfo.funnel_interstitial_opps_per_round.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_interstitial_opps_per_round.cn}}',
                                      explainEn:
                                        '{{metricsInfo.funnel_interstitial_opps_per_round.explainEn}}',
                                      explainCn:
                                        '{{metricsInfo.funnel_interstitial_opps_per_round.explainCn}}',
                                      formatRule:
                                        '{{metricsInfo.funnel_interstitial_opps_per_round.formatter}}',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 8 },
                          children: [
                            {
                              name: 'MetricCard',
                              type: 'view',
                              props: {
                                config: {
                                  componentMetrics: [
                                    {
                                      icon: 'game',
                                      metricKey: 'funnel_impression_per_level',
                                      enName:
                                        '{{metricsInfo.funnel_impression_per_level_interstitial.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_impression_per_level_interstitial.cn}}',
                                      explainEn:
                                        '{{metricsInfo.funnel_impression_per_level_interstitial.explainEn}}',
                                      explainCn:
                                        '{{metricsInfo.funnel_impression_per_level_interstitial.explainCn}}',
                                      formatRule:
                                        '{{metricsInfo.funnel_impression_per_level_interstitial.formatter}}',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'KeyMetricsCo',
                  className: '',
                  type: 'view',
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/overview_daily/card_metrics',
                      mainMetricsList: [
                        'funnel_ready_rate_per',
                        'funnel_rewarded_opps_per_round',
                        'funnel_impression_per_level',
                      ],
                      metricsList: [
                        'funnel_ready_rate_per',
                        'funnel_rewarded_opps_per_round',
                        'funnel_impression_per_level',
                      ],
                      haveJump: false,
                      loadingHeight: 200,
                      otherParams(data: any) {
                        const existingCustomFilters =
                          data?.custom_filters || [];
                        const adFormatFilter = existingCustomFilters.find(
                          (item: any) => item.key === 'ad_format',
                        );
                        if (adFormatFilter) {
                          adFormatFilter.filter_list = ['rewarded'];
                        } else {
                          existingCustomFilters.push({
                            key: 'ad_format',
                            filter_list: ['rewarded'],
                          });
                        }
                        return {
                          logical_flag: 'ad_format_all',
                          filters: Object.assign({}, data, {
                            custom_filters: existingCustomFilters,
                          }),
                        };
                      },
                    },
                  },
                  children: [
                    {
                      name: 'CommonRow',
                      className: 'margin-t-10',
                      children: [
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 8 },
                          children: [
                            {
                              name: 'MetricCard',
                              type: 'view',
                              props: {
                                config: {
                                  isLeftCard: true,
                                  componentMetrics: [
                                    {
                                      icon: 'pie-chart-icon',
                                      metricKey: 'funnel_ready_rate_per',
                                      enName:
                                        '{{metricsInfo.funnel_ready_rate_per_rewarded.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_ready_rate_per_rewarded.cn}}',
                                      explainEn:
                                        '{{metricsInfo.funnel_ready_rate_per_rewarded.explainEn}}',
                                      explainCn:
                                        '{{metricsInfo.funnel_ready_rate_per_rewarded.explainCn}}',
                                      formatRule:
                                        '{{metricsInfo.funnel_ready_rate_per_rewarded.formatter}}',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 8 },
                          children: [
                            {
                              name: 'MetricCard',
                              type: 'view',
                              props: {
                                config: {
                                  componentMetrics: [
                                    {
                                      icon: 'pie-chart-icon',
                                      metricKey:
                                        'funnel_rewarded_opps_per_round',
                                      enName:
                                        '{{metricsInfo.funnel_rewarded_opps_per_round.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_rewarded_opps_per_round.cn}}',
                                      explainEn:
                                        '{{metricsInfo.funnel_rewarded_opps_per_round.explainEn}}',
                                      explainCn:
                                        '{{metricsInfo.funnel_rewarded_opps_per_round.explainCn}}',
                                      formatRule:
                                        '{{metricsInfo.funnel_rewarded_opps_per_round.formatter}}',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 8 },
                          children: [
                            {
                              name: 'MetricCard',
                              type: 'view',
                              props: {
                                config: {
                                  componentMetrics: [
                                    {
                                      icon: 'game',
                                      metricKey: 'funnel_impression_per_level',
                                      enName:
                                        '{{metricsInfo.funnel_impression_per_level_rewarded.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_impression_per_level_rewarded.cn}}',
                                      explainEn:
                                        '{{metricsInfo.funnel_impression_per_level_rewarded.explainEn}}',
                                      explainCn:
                                        '{{metricsInfo.funnel_impression_per_level_rewarded.explainCn}}',
                                      formatRule:
                                        '{{metricsInfo.funnel_impression_per_level_rewarded.formatter}}',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'FormattedService',
                  className: '',
                  type: 'view',
                  props: {
                    api: '/api/v1/dashboard/pc/overview_daily/funnel',
                    dataKey: 'funnelData',
                    trackData: ['gameCode'],
                    metrics: [
                      'funnel_sdk_init_succ_rate_per',
                      'funnel_iaa_sdk_inits',
                      'funnel_request_completion_rate_per',
                      'funnel_iaa_requests',
                      'funnel_cache_succ_rate_per',
                      'funnel_iaa_loaded',
                      'funnel_ready_rate_per',
                      'funnel_iaa_opportunity_ready',
                      'funnel_show_succ_rate_per',
                      'funnel_iaa_impressions',
                      'funnel_show_fail_rate_per',
                      'funnel_completion_rate_per',
                      'funnel_iaa_hidden',
                      'funnel_click_rate_per',
                      'funnel_iaa_clicks',
                    ],
                    beforeRequest(params: any, data: any) {
                      const filterVal = data?.filterVal || {};
                      if (!filterVal?.rangeTime?.[0]) return false;
                      const existingCustomFilters =
                        params?.filters?.custom_filters || [];
                      const hasAdFormat = existingCustomFilters.some(
                        (item: any) => item.key === 'ad_format',
                      );
                      if (!hasAdFormat) {
                        existingCustomFilters.push({
                          key: 'ad_format',
                          filter_list: ['interstitial', 'rewarded'],
                        });
                      }
                      return Object.assign({}, params, {
                        logical_flag: 'ad_format_all',
                        filters: Object.assign({}, params?.filters, {
                          custom_filters: existingCustomFilters,
                        }),
                        accumulation: {
                          not_by_date: true,
                          custom_accumulation: [
                            { key: 'ad_format', is_accumulation: true },
                          ],
                        },
                      });
                    },
                  },
                  children: [
                    {
                      name: 'CardState',
                      className: 'margin-t-10',
                      style: { minHeight: '600px' },
                      props: { apiGroup: ['funnelData'] },
                      children: [
                        {
                          name: 'CommonRow',
                          children: [
                            {
                              name: 'CommonCol',
                              type: 'layout',
                              props: { w: 12 },
                              children: [
                                {
                                  name: 'MetricBarCard',
                                  type: 'view',
                                  props: {
                                    titleEn: 'Interstitial Funnel',
                                    titleCn: '插屏广告漏斗',
                                    showTime: false,
                                    dataKey: 'funnelData',
                                    formatData(metricData: any) {
                                      const list = metricData?.list || [];
                                      const row =
                                        list.find(
                                          (item: any) =>
                                            item?.name === 'interstitial',
                                        ) || {};
                                      const metrics = row?.metrics || {};
                                      return Object.keys(metrics).map(key => ({
                                        metrics_name: key,
                                        value: metrics[key]?.value || '',
                                        dod: metrics[key]?.dod || '',
                                      }));
                                    },
                                    componentMetrics: [
                                      {
                                        metricKey:
                                          'funnel_sdk_init_succ_rate_per',
                                        nameEn: '{{metricsInfo.funnel_sdk_init_succ_rate_per.en}}:',
                                        nameCn: '{{metricsInfo.funnel_sdk_init_succ_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.funnel_sdk_init_succ_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.funnel_sdk_init_succ_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.funnel_sdk_init_succ_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_sdk_inits',
                                        nameEn: 'Initialization',
                                        nameCn: '初始化',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_sdk_inits.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_sdk_inits.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey:
                                          'funnel_request_completion_rate_per',
                                        nameEn:
                                          '{{metricsInfo.request_completion_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.request_completion_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.request_completion_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.request_completion_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.request_completion_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_requests',
                                        nameEn: 'Request',
                                        nameCn: '请求',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_requests.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_requests.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_cache_succ_rate_per',
                                        nameEn:
                                          '{{metricsInfo.cache_succ_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.cache_succ_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.cache_succ_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.cache_succ_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.cache_succ_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_loaded',
                                        nameEn: 'Cache',
                                        nameCn: '缓存',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_loaded.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_loaded.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_ready_rate_per',
                                        nameEn:
                                          '{{metricsInfo.ready_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.ready_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.ready_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.ready_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.ready_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey:
                                          'funnel_iaa_opportunity_ready',
                                        nameEn: 'Ready',
                                        nameCn: '就绪',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_opportunity_ready.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_opportunity_ready.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_show_succ_rate_per',
                                        nameEn:
                                          '{{metricsInfo.show_succ_fail_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.show_succ_fail_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.show_succ_fail_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.show_succ_fail_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.show_succ_fail_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_show_fail_rate_per',
                                        nameEn: 'Show Failure Rate%',
                                        nameCn: '展示失败率',
                                        formatter:
                                          '{{metricsInfo.show_succ_fail_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.show_succ_fail_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.show_succ_fail_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_impressions',
                                        nameEn: 'Show',
                                        nameCn: '展示',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.funnel_iaa_impressions.en}}',
                                        explainCn:
                                          '{{metricsInfo.funnel_iaa_impressions.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_completion_rate_per',
                                        nameEn:
                                          '{{metricsInfo.completion_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.completion_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.completion_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.completion_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.completion_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_hidden',
                                        nameEn: 'Completion',
                                        nameCn: '完播',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_hidden.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_hidden.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_click_rate_per',
                                        nameEn:
                                          '{{metricsInfo.click_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.click_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.click_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.click_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.click_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_clicks',
                                        nameEn: 'Click',
                                        nameCn: '点击',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.funnel_iaa_clicks.en}}',
                                        explainCn:
                                          '{{metricsInfo.funnel_iaa_clicks.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                    ],
                                    bars: [
                                      {
                                        labelEn: '01. Initialization',
                                        labelCn: '01. 初始化',
                                        color: ['#029CD4', '#029CD4'],
                                        infoIconColor: '#A7E7FF',
                                        metric1: {
                                          metricKey:
                                            'funnel_sdk_init_succ_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_sdk_inits',
                                        },
                                      },
                                      {
                                        labelEn: '02. Request',
                                        labelCn: '02. 请求',
                                        color: ['#5086F3', '#5086F3'],
                                        infoIconColor: '#A6C9FF',
                                        metric1: {
                                          metricKey:
                                            'funnel_request_completion_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_requests',
                                        },
                                      },
                                      {
                                        labelEn: '03. Cache',
                                        labelCn: '03. 缓存',
                                        color: ['#40B77A', '#40B77A'],
                                        infoIconColor: '#C0EBD2',
                                        metric1: {
                                          metricKey:
                                            'funnel_cache_succ_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_loaded',
                                        },
                                      },
                                      {
                                        labelEn: '04. Ready',
                                        labelCn: '04. 就绪',
                                        color: ['#7F6FF1', '#7F6FF1'],
                                        infoIconColor: '#D2C8FD',
                                        metric1: {
                                          metricKey: 'funnel_ready_rate_per',
                                        },
                                        metric2: {
                                          metricKey:
                                            'funnel_iaa_opportunity_ready',
                                        },
                                      },
                                      {
                                        labelEn: '05. Show',
                                        labelCn: '05. 展示',
                                        color: ['#F19E55', '#F19E55'],
                                        infoIconColor: '#FFC893',
                                        metric1: {
                                          metricKey:
                                            'funnel_show_succ_rate_per',
                                        },
                                        extraMetrics: [
                                          {
                                            metricKey:
                                              'funnel_show_fail_rate_per',
                                          },
                                        ],
                                        extraMetricsSeparator: '&',
                                        metric2: {
                                          metricKey: 'funnel_iaa_impressions',
                                        },
                                      },
                                      {
                                        labelEn: '06. Completion',
                                        labelCn: '06. 完播',
                                        color: ['#488E89', '#488E89'],
                                        infoIconColor: '#A9C7C3',
                                        metric1: {
                                          metricKey:
                                            'funnel_completion_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_hidden',
                                        },
                                      },
                                      {
                                        labelEn: '07. Click',
                                        labelCn: '07. 点击',
                                        color: ['#838697', '#838697'],
                                        infoIconColor: '#D8DAE4',
                                        metric1: {
                                          metricKey: 'funnel_click_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_clicks',
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                            {
                              name: 'CommonCol',
                              type: 'layout',
                              props: { w: 12 },
                              children: [
                                {
                                  name: 'MetricBarCard',
                                  type: 'view',
                                  props: {
                                    titleEn: 'Rewarded Funnel',
                                    titleCn: '激励广告漏斗',
                                    showTime: false,
                                    dataKey: 'funnelData',
                                    formatData(metricData: any) {
                                      const list = metricData?.list || [];
                                      const row =
                                        list.find(
                                          (item: any) =>
                                            item?.name === 'rewarded',
                                        ) || {};
                                      const metrics = row?.metrics || {};
                                      return Object.keys(metrics).map(key => ({
                                        metrics_name: key,
                                        value: metrics[key]?.value || '',
                                        dod: metrics[key]?.dod || '',
                                      }));
                                    },
                                    componentMetrics: [
                                      {
                                        metricKey:
                                          'funnel_sdk_init_succ_rate_per',
                                        nameEn: '{{metricsInfo.funnel_sdk_init_succ_rate_per.en}}:',
                                        nameCn: '{{metricsInfo.funnel_sdk_init_succ_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.funnel_sdk_init_succ_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.funnel_sdk_init_succ_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.funnel_sdk_init_succ_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_sdk_inits',
                                        nameEn: 'Initialization',
                                        nameCn: '初始化',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_sdk_inits.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_sdk_inits.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey:
                                          'funnel_request_completion_rate_per',
                                        nameEn:
                                          '{{metricsInfo.request_completion_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.request_completion_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.request_completion_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.request_completion_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.request_completion_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_requests',
                                        nameEn: 'Request',
                                        nameCn: '请求',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_requests.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_requests.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_cache_succ_rate_per',
                                        nameEn:
                                          '{{metricsInfo.cache_succ_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.cache_succ_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.cache_succ_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.cache_succ_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.cache_succ_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_loaded',
                                        nameEn: 'Cache',
                                        nameCn: '缓存',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_loaded.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_loaded.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_ready_rate_per',
                                        nameEn:
                                          '{{metricsInfo.ready_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.ready_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.ready_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.ready_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.ready_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey:
                                          'funnel_iaa_opportunity_ready',
                                        nameEn: 'Ready',
                                        nameCn: '就绪',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_opportunity_ready.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_opportunity_ready.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_show_succ_rate_per',
                                        nameEn:
                                          '{{metricsInfo.show_succ_fail_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.show_succ_fail_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.show_succ_fail_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.show_succ_fail_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.show_succ_fail_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_show_fail_rate_per',
                                        nameEn: 'Show Failure Rate%',
                                        nameCn: '展示失败率',
                                        formatter:
                                          '{{metricsInfo.show_succ_fail_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.show_succ_fail_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.show_succ_fail_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_impressions',
                                        nameEn: 'Show',
                                        nameCn: '展示',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.funnel_iaa_impressions.en}}',
                                        explainCn:
                                          '{{metricsInfo.funnel_iaa_impressions.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_completion_rate_per',
                                        nameEn:
                                          '{{metricsInfo.completion_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.completion_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.completion_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.completion_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.completion_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_hidden',
                                        nameEn: 'Completion',
                                        nameCn: '完播',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.iaa_hidden.en}}',
                                        explainCn:
                                          '{{metricsInfo.iaa_hidden.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                      {
                                        metricKey: 'funnel_click_rate_per',
                                        nameEn:
                                          '{{metricsInfo.click_rate_per.en}}:',
                                        nameCn:
                                          '{{metricsInfo.click_rate_per.cn}}:',
                                        formatter:
                                          '{{metricsInfo.click_rate_per.formatter}}',
                                        explainEn:
                                          '{{metricsInfo.click_rate_per.explainEn}}',
                                        explainCn:
                                          '{{metricsInfo.click_rate_per.explainCn}}',
                                        preUnit: '',
                                        endUnit: '',
                                        moreThan100Show100: false,
                                      },
                                      {
                                        metricKey: 'funnel_iaa_clicks',
                                        nameEn: 'Click',
                                        nameCn: '点击',
                                        formatter: 'thousandsInit',
                                        explainEn:
                                          '{{metricsInfo.funnel_iaa_clicks.en}}',
                                        explainCn:
                                          '{{metricsInfo.funnel_iaa_clicks.cn}}',
                                        preUnit: '',
                                        endUnit: ' times',
                                      },
                                    ],
                                    bars: [
                                      {
                                        labelEn: '01. Initialization',
                                        labelCn: '01. 初始化',
                                        color: ['#029CD4', '#029CD4'],
                                        infoIconColor: '#A7E7FF',
                                        metric1: {
                                          metricKey:
                                            'funnel_sdk_init_succ_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_sdk_inits',
                                        },
                                      },
                                      {
                                        labelEn: '02. Request',
                                        labelCn: '02. 请求',
                                        color: ['#5086F3', '#5086F3'],
                                        infoIconColor: '#A6C9FF',
                                        metric1: {
                                          metricKey:
                                            'funnel_request_completion_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_requests',
                                        },
                                      },
                                      {
                                        labelEn: '03. Cache',
                                        labelCn: '03. 缓存',
                                        color: ['#40B77A', '#40B77A'],
                                        infoIconColor: '#C0EBD2',
                                        metric1: {
                                          metricKey:
                                            'funnel_cache_succ_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_loaded',
                                        },
                                      },
                                      {
                                        labelEn: '04. Ready',
                                        labelCn: '04. 就绪',
                                        color: ['#7F6FF1', '#7F6FF1'],
                                        infoIconColor: '#D2C8FD',
                                        metric1: {
                                          metricKey: 'funnel_ready_rate_per',
                                        },
                                        metric2: {
                                          metricKey:
                                            'funnel_iaa_opportunity_ready',
                                        },
                                      },
                                      {
                                        labelEn: '05. Show',
                                        labelCn: '05. 展示',
                                        color: ['#F19E55', '#F19E55'],
                                        infoIconColor: '#FFC893',
                                        metric1: {
                                          metricKey:
                                            'funnel_show_succ_rate_per',
                                        },
                                        extraMetrics: [
                                          {
                                            metricKey:
                                              'funnel_show_fail_rate_per',
                                          },
                                        ],
                                        extraMetricsSeparator: '&',
                                        metric2: {
                                          metricKey: 'funnel_iaa_impressions',
                                        },
                                      },
                                      {
                                        labelEn: '06. Completion',
                                        labelCn: '06. 完播',
                                        color: ['#488E89', '#488E89'],
                                        infoIconColor: '#A9C7C3',
                                        metric1: {
                                          metricKey:
                                            'funnel_completion_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_hidden',
                                        },
                                      },
                                      {
                                        labelEn: '07. Click',
                                        labelCn: '07. 点击',
                                        color: ['#838697', '#838697'],
                                        infoIconColor: '#D8DAE4',
                                        metric1: {
                                          metricKey: 'funnel_click_rate_per',
                                        },
                                        metric2: {
                                          metricKey: 'funnel_iaa_clicks',
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'SegmentCo',
                  className: 'segment-light margin-t-20',
                  type: 'view',
                  data: {
                    adFormatType: 'interstitial',
                  },
                  props: {
                    config: {
                      options: [
                        {
                          value: 'interstitial',
                          name: 'Interstitial',
                          nameCn: '插屏广告',
                          bubble: '',
                          bubbleCn: '',
                        },
                        {
                          value: 'rewarded',
                          name: 'Rewarded',
                          nameCn: '激励广告',
                          bubble: '',
                          bubbleCn: '',
                        },
                      ],
                      dataKey: 'adFormatType',
                    },
                  },
                  children: [
                    {
                      name: 'CommonRow',
                      className: 'margin-t-10 margin-b-10',
                      children: [
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 12 },
                          children: [
                            {
                              name: 'FormattedService',
                              type: 'view',
                              data: {
                                segmentValue: 'rate',
                              },
                              props: {
                                api: '/api/v1/dashboard/pc/overview_daily/metrics_trend',
                                dataKey: 'data',
                                trackData: ['gameCode', 'adFormatType'],
                                metrics: [
                                  'funnel_sdk_init_succ_rate_per',
                                  'funnel_request_completion_rate_per',
                                  'funnel_cache_succ_rate_per',
                                  'funnel_ready_rate_per',
                                  'funnel_show_succ_rate_per',
                                  'funnel_show_fail_rate_per',
                                  'funnel_completion_rate_per',
                                  'funnel_click_rate_per',
                                  'funnel_session_start_cnt',
                                  'funnel_iaa_sdk_inits',
                                  'funnel_iaa_requests',
                                  'funnel_iaa_loaded',
                                  'funnel_iaa_load_failed',
                                  'funnel_iaa_opportunity_ready',
                                  'funnel_iaa_opportunitys',
                                  'funnel_iaa_impressions',
                                  'funnel_iaa_impression_failed',
                                  'funnel_iaa_hidden',
                                  'funnel_iaa_clicks',
                                ],
                                beforeRequest(params: any, data: any) {
                                  const filterVal = data?.filterVal || {};
                                  const { rangeTime } = filterVal;
                                  if (!rangeTime?.[0]) return false;
                                  const adFormat =
                                    data?.adFormatType || 'interstitial';
                                  const existingCustomFilters =
                                    params?.filters?.custom_filters || [];
                                  const hasAdFormat =
                                    existingCustomFilters.some(
                                      (item: any) => item.key === 'ad_format',
                                    );
                                  if (!hasAdFormat) {
                                    existingCustomFilters.push({
                                      key: 'ad_format',
                                      filter_list: [adFormat],
                                    });
                                  }
                                  const startDate = new Date(rangeTime[0]);
                                  startDate.setDate(startDate.getDate() - 13);
                                  const startTime = [
                                    startDate.getFullYear(),
                                    String(startDate.getMonth() + 1).padStart(
                                      2,
                                      '0',
                                    ),
                                    String(startDate.getDate()).padStart(
                                      2,
                                      '0',
                                    ),
                                  ].join('-');
                                  return Object.assign({}, params, {
                                    start_time: startTime,
                                    logical_flag: 'ad_format_all',
                                    filters: Object.assign(
                                      {},
                                      params?.filters,
                                      {
                                        custom_filters: existingCustomFilters,
                                      },
                                    ),
                                  });
                                },
                              },
                              children: [
                                {
                                  name: 'MetricsUserCompositionCo',
                                  type: 'view',
                                  props: {
                                    config: {
                                      titleEn: 'Trends',
                                      titleCn: '趋势图',
                                      showComList: [
                                        'barChart',
                                        'lineChart',
                                        'sheet',
                                      ],
                                      initChartIndex: 1,
                                      chartHeight: 390,
                                      tableScrollHeight: 354,
                                      tooltipSort: 'desc',
                                      operationInTitle: true,
                                      noStack: false,
                                      tooltipSegmentLabel: true,
                                      segmentDataKey: 'segmentValue',
                                      componentSegment: [
                                        {
                                          value: 'rate',
                                          enName: 'Rate%',
                                          cnName: '转化率%',
                                        },
                                        {
                                          value: 'count',
                                          enName: 'Count',
                                          cnName: '设备数',
                                        },
                                      ],
                                      multiMetricsMap: {
                                        rate: [
                                          {
                                            key: 'funnel_sdk_init_succ_rate_per',
                                            enName:
                                              '{{metricsInfo.funnel_sdk_init_succ_rate_per.en}}',
                                            cnName:
                                              '{{metricsInfo.funnel_sdk_init_succ_rate_per.cn}}',
                                            formatter:
                                              '{{metricsInfo.funnel_sdk_init_succ_rate_per.formatter}}',
                                            yAxisFormatter: 'percentInt',
                                            columnWidthEn: 170,
                                            columnWidthCn: 130,
                                          },
                                          {
                                            key: 'funnel_request_completion_rate_per',
                                            enName:
                                              '{{metricsInfo.request_completion_rate_per.en}}',
                                            cnName:
                                              '{{metricsInfo.request_completion_rate_per.cn}}',
                                            formatter:
                                              '{{metricsInfo.request_completion_rate_per.formatter}}',
                                            yAxisFormatter: 'percentInt',
                                            columnWidthEn: 190,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_cache_succ_rate_per',
                                            enName:
                                              '{{metricsInfo.cache_succ_rate_per.en}}',
                                            cnName:
                                              '{{metricsInfo.cache_succ_rate_per.cn}}',
                                            formatter:
                                              '{{metricsInfo.cache_succ_rate_per.formatter}}',
                                            yAxisFormatter: 'percentInt',
                                            columnWidthEn: 170,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_ready_rate_per',
                                            enName:
                                              '{{metricsInfo.ready_rate_per.en}}',
                                            cnName:
                                              '{{metricsInfo.ready_rate_per.cn}}',
                                            formatter:
                                              '{{metricsInfo.ready_rate_per.formatter}}',
                                            yAxisFormatter: 'percentInt',
                                          },
                                          {
                                            key: 'funnel_show_succ_rate_per',
                                            enName:
                                              '{{metricsInfo.show_succ_rate_per.en}}',
                                            cnName:
                                              '{{metricsInfo.show_succ_rate_per.cn}}',
                                            formatter:
                                              '{{metricsInfo.show_succ_rate_per.formatter}}',
                                            yAxisFormatter: 'percentInt',
                                            columnWidthEn: 150,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_show_fail_rate_per',
                                            enName:
                                              '{{metricsInfo.show_fail_rate_per.en}}',
                                            cnName:
                                              '{{metricsInfo.show_fail_rate_per.cn}}',
                                            formatter:
                                              '{{metricsInfo.show_fail_rate_per.formatter}}',
                                            yAxisFormatter: 'percentInt',
                                            columnWidthEn: 140,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_completion_rate_per',
                                            enName:
                                              '{{metricsInfo.completion_rate_per.en}}',
                                            cnName:
                                              '{{metricsInfo.completion_rate_per.cn}}',
                                            formatter:
                                              '{{metricsInfo.completion_rate_per.formatter}}',
                                            yAxisFormatter: 'percentInt',
                                            columnWidthEn: 130,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_click_rate_per',
                                            enName:
                                              '{{metricsInfo.click_rate_per.en}}',
                                            cnName:
                                              '{{metricsInfo.click_rate_per.cn}}',
                                            formatter:
                                              '{{metricsInfo.click_rate_per.formatter}}',
                                            yAxisFormatter: 'percentInt',
                                          },
                                        ],
                                        count: [
                                          {
                                            key: 'funnel_iaa_sdk_inits',
                                            enName:
                                              '{{metricsInfo.iaa_sdk_inits.en}}',
                                            cnName:
                                              '{{metricsInfo.iaa_sdk_inits.cn}}',
                                            formatter:
                                              '{{metricsInfo.iaa_sdk_inits.formatter}}',
                                            yAxisFormatter: 'bmk',
                                            columnWidthEn: 140,
                                            columnWidthCn: 130,
                                          },
                                          {
                                            key: 'funnel_session_start_cnt',
                                            enName:
                                              '{{metricsInfo.session_start_cnt.en}}',
                                            cnName:
                                              '{{metricsInfo.session_start_cnt.cn}}',
                                            formatter:
                                              '{{metricsInfo.session_start_cnt.formatter}}',
                                            yAxisFormatter: 'bmk',
                                          },
                                          {
                                            key: 'funnel_iaa_loaded',
                                            enName:
                                              '{{metricsInfo.iaa_loaded.en}}',
                                            cnName:
                                              '{{metricsInfo.iaa_loaded.cn}}',
                                            formatter:
                                              '{{metricsInfo.iaa_loaded.formatter}}',
                                            yAxisFormatter: 'bmk',
                                            columnWidthEn: 130,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_iaa_load_failed',
                                            enName:
                                              '{{metricsInfo.iaa_load_failed.en}}',
                                            cnName:
                                              '{{metricsInfo.iaa_load_failed.cn}}',
                                            formatter:
                                              '{{metricsInfo.iaa_load_failed.formatter}}',
                                            yAxisFormatter: 'bmk',
                                          },
                                          {
                                            key: 'funnel_iaa_requests',
                                            enName:
                                              '{{metricsInfo.iaa_requests.en}}',
                                            cnName:
                                              '{{metricsInfo.iaa_requests.cn}}',
                                            formatter:
                                              '{{metricsInfo.iaa_requests.formatter}}',
                                            yAxisFormatter: 'bmk',
                                            columnWidthEn: 130,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_iaa_opportunity_ready',
                                            enName:
                                              '{{metricsInfo.iaa_opportunity_ready.en}}',
                                            cnName:
                                              '{{metricsInfo.iaa_opportunity_ready.cn}}',
                                            formatter:
                                              '{{metricsInfo.iaa_opportunity_ready.formatter}}',
                                            yAxisFormatter: 'bmk',
                                            columnWidthEn: 220,
                                            columnWidthCn: 140,
                                          },
                                          {
                                            key: 'funnel_iaa_opportunitys',
                                            enName:
                                              '{{metricsInfo.level_end_cnt.en}}',
                                            cnName:
                                              '{{metricsInfo.level_end_cnt.cn}}',
                                            formatter:
                                              '{{metricsInfo.level_end_cnt.formatter}}',
                                            yAxisFormatter: 'bmk',
                                          },
                                          {
                                            key: 'funnel_iaa_impressions',
                                            enName:
                                              '{{metricsInfo.funnel_iaa_impressions.en}}',
                                            cnName:
                                              '{{metricsInfo.funnel_iaa_impressions.cn}}',
                                            formatter:
                                              '{{metricsInfo.funnel_iaa_impressions.formatter}}',
                                            yAxisFormatter: 'bmk',
                                            columnWidthEn: 190,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_iaa_impression_failed',
                                            enName:
                                              '{{metricsInfo.iaa_impression_failed.en}}',
                                            cnName:
                                              '{{metricsInfo.iaa_impression_failed.cn}}',
                                            formatter:
                                              '{{metricsInfo.iaa_impression_failed.formatter}}',
                                            yAxisFormatter: 'bmk',
                                            columnWidthEn: 160,
                                            columnWidthCn: 100,
                                          },                             
                                          {
                                            key: 'funnel_iaa_hidden',
                                            enName:
                                              '{{metricsInfo.iaa_hidden.en}}',
                                            cnName:
                                              '{{metricsInfo.iaa_hidden.cn}}',
                                            formatter:
                                              '{{metricsInfo.iaa_hidden.formatter}}',
                                            yAxisFormatter: 'bmk',
                                            columnWidthEn: 120,
                                            columnWidthCn: 100,
                                          },
                                          {
                                            key: 'funnel_iaa_clicks',
                                            enName:
                                              '{{metricsInfo.funnel_iaa_clicks.en}}',
                                            cnName:
                                              '{{metricsInfo.funnel_iaa_clicks.cn}}',
                                            formatter:
                                              '{{metricsInfo.funnel_iaa_clicks.formatter}}',
                                            yAxisFormatter: 'bmk',
                                          },
                                        ],
                                      },
                                    },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          name: 'CommonCol',
                          type: 'layout',
                          props: { w: 12 },
                          children: [
                            {
                              name: 'AdFunnelTrendStep',
                              type: 'view',
                              props: {
                                apiConfig: {
                                  trendApi:
                                    '/api/v1/dashboard/pc/overview_daily/metrics_trend',
                                  dimensionApi:
                                    '/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend',
                                  logicalFlag: 'ad_format_all',
                                  dimensionLogicalFlag:
                                    'ad_format_all,show_all_data',
                                  topNum: 10,
                                  period: 'daily',
                                  daysBack: 13,
                                  customAccumulationKeys: [
                                    'campaign',
                                    'network_type',
                                    'ua_network',
                                    'user_type',
                                    'version',
                                    'ad_format',
                                  ],
                                },
                                configMode: true,
                                noStack: false,
                                dropdownClassName:
                                  'dbd-ad-funnel-metric-dropdown',
                                dropdownStyle: {
                                  rate: {
                                    buttonWidthEn: 280,
                                    buttonWidthCn: 260,
                                    panelMinWidth: 280,
                                  },
                                  count: {
                                    buttonWidthEn: 300,
                                    buttonWidthCn: 260,
                                    panelMinWidth: 280,
                                  },
                                },
                                titleConfig: {
                                  titleEn: 'Trends Breakdown',
                                  titleCn: '趋势图分维度',
                                },
                                segmentConfig: {
                                  options: [
                                    {
                                      textEn: 'Rate%',
                                      textCn: '转化率%',
                                      value: 'rate',
                                    },
                                    {
                                      textEn: 'Count',
                                      textCn: '设备数',
                                      value: 'count',
                                    },
                                  ],
                                  defaultValue: 'rate',
                                },
                                metricOptions: {
                                  rate: [
                                    {
                                      value: 'funnel_sdk_init_succ_rate_per',
                                      enName:
                                        '{{metricsInfo.funnel_sdk_init_succ_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_sdk_init_succ_rate_per.cn}}',
                                      formatter:
                                        '{{metricsInfo.funnel_sdk_init_succ_rate_per.formatter}}',
                                      yAxisFormatter: 'percentInt',
                                      sortMetric: 'funnel_session_start_cnt',
                                    },
                                    {
                                      value:
                                        'funnel_request_completion_rate_per',
                                      enName:
                                        '{{metricsInfo.request_completion_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.request_completion_rate_per.cn}}',
                                      formatter:
                                        '{{metricsInfo.request_completion_rate_per.formatter}}',
                                      yAxisFormatter: 'percentInt',
                                      sortMetric: 'funnel_iaa_requests',
                                    },
                                    {
                                      value: 'funnel_cache_succ_rate_per',
                                      enName:
                                        '{{metricsInfo.cache_succ_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.cache_succ_rate_per.cn}}',
                                      formatter:
                                        '{{metricsInfo.cache_succ_rate_per.formatter}}',
                                      yAxisFormatter: 'percentInt',
                                      sortMetric: 'funnel_iaa_requests',
                                    },
                                    {
                                      value: 'funnel_ready_rate_per',
                                      default: true,
                                      enName:
                                        '{{metricsInfo.ready_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.ready_rate_per.cn}}',
                                      formatter:
                                        '{{metricsInfo.ready_rate_per.formatter}}',
                                      yAxisFormatter: 'percentInt',
                                      sortMetric: 'funnel_iaa_opportunitys',
                                    },
                                    {
                                      value: 'funnel_show_succ_rate_per',
                                      enName:
                                        '{{metricsInfo.show_succ_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.show_succ_rate_per.cn}}',
                                      formatter:
                                        '{{metricsInfo.show_succ_rate_per.formatter}}',
                                      yAxisFormatter: 'percentInt',
                                      sortMetric: 'funnel_iaa_opportunity_ready',
                                    },
                                    {
                                      value: 'funnel_show_fail_rate_per',
                                      enName:
                                        '{{metricsInfo.show_fail_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.show_fail_rate_per.cn}}',
                                      formatter:
                                        '{{metricsInfo.show_fail_rate_per.formatter}}',
                                      yAxisFormatter: 'percentInt',
                                      sortMetric: 'funnel_iaa_impression_failed',
                                    },
                                    {
                                      value: 'funnel_completion_rate_per',
                                      enName:
                                        '{{metricsInfo.completion_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.completion_rate_per.cn}}',
                                      formatter:
                                        '{{metricsInfo.completion_rate_per.formatter}}',
                                      yAxisFormatter: 'percentInt',
                                      sortMetric: 'funnel_iaa_hidden',
                                    },
                                    {
                                      value: 'funnel_click_rate_per',
                                      enName:
                                        '{{metricsInfo.click_rate_per.en}}',
                                      cnName:
                                        '{{metricsInfo.click_rate_per.cn}}',
                                      formatter:
                                        '{{metricsInfo.click_rate_per.formatter}}',
                                      yAxisFormatter: 'percentInt',
                                      sortMetric: 'funnel_iaa_impressions',
                                    },
                                  ],
                                  count: [
                                    {
                                      value: 'funnel_iaa_sdk_inits',
                                      enName:
                                        '{{metricsInfo.iaa_sdk_inits.en}}',
                                      cnName:
                                        '{{metricsInfo.iaa_sdk_inits.cn}}',
                                      formatter:
                                        '{{metricsInfo.iaa_sdk_inits.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_session_start_cnt',
                                      enName:
                                        '{{metricsInfo.session_start_cnt.en}}',
                                      cnName:
                                        '{{metricsInfo.session_start_cnt.cn}}',
                                      formatter:
                                        '{{metricsInfo.session_start_cnt.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_loaded',
                                      enName: '{{metricsInfo.iaa_loaded.en}}',
                                      cnName: '{{metricsInfo.iaa_loaded.cn}}',
                                      formatter:
                                        '{{metricsInfo.iaa_loaded.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_load_failed',
                                      enName:
                                        '{{metricsInfo.iaa_load_failed.en}}',
                                      cnName:
                                        '{{metricsInfo.iaa_load_failed.cn}}',
                                      formatter:
                                        '{{metricsInfo.iaa_load_failed.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_requests',
                                      enName: '{{metricsInfo.iaa_requests.en}}',
                                      cnName: '{{metricsInfo.iaa_requests.cn}}',
                                      formatter:
                                        '{{metricsInfo.iaa_requests.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_opportunity_ready',
                                      enName:
                                        '{{metricsInfo.iaa_opportunity_ready.en}}',
                                      cnName:
                                        '{{metricsInfo.iaa_opportunity_ready.cn}}',
                                      formatter:
                                        '{{metricsInfo.iaa_opportunity_ready.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_opportunitys',
                                      enName:
                                        '{{metricsInfo.level_end_cnt.en}}',
                                      cnName:
                                        '{{metricsInfo.level_end_cnt.cn}}',
                                      formatter:
                                        '{{metricsInfo.level_end_cnt.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_impressions',
                                      default: true,
                                      enName:
                                        '{{metricsInfo.funnel_iaa_impressions.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_iaa_impressions.cn}}',
                                      formatter:
                                        '{{metricsInfo.funnel_iaa_impressions.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_impression_failed',
                                      default: true,
                                      enName:
                                        '{{metricsInfo.iaa_impression_failed.en}}',
                                      cnName:
                                        '{{metricsInfo.iaa_impression_failed.cn}}',
                                      formatter:
                                        '{{metricsInfo.iaa_impression_failed.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_hidden',
                                      enName: '{{metricsInfo.iaa_hidden.en}}',
                                      cnName: '{{metricsInfo.iaa_hidden.cn}}',
                                      formatter:
                                        '{{metricsInfo.iaa_hidden.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                    {
                                      value: 'funnel_iaa_clicks',
                                      enName:
                                        '{{metricsInfo.funnel_iaa_clicks.en}}',
                                      cnName:
                                        '{{metricsInfo.funnel_iaa_clicks.cn}}',
                                      formatter:
                                        '{{metricsInfo.funnel_iaa_clicks.formatter}}',
                                      yAxisFormatter: 'bmk',
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'MetricComponent',
                  path: 'monetization/adFunnel',
                  componentKey: 'OverallTableCo',
                  height: 757,
                  data: {
                    tableMetric: [
                      'funnel_sdk_init_succ_rate_per',
                      'funnel_request_completion_rate_per',
                      'funnel_cache_succ_rate_per',
                      'funnel_ready_rate_per',
                      'funnel_show_succ_rate_per',
                      'funnel_show_fail_rate_per',
                      'funnel_completion_rate_per',
                      'funnel_click_rate_per',
                      'funnel_session_start_cnt',
                      'funnel_iaa_sdk_inits',
                      'funnel_iaa_requests',
                      'funnel_iaa_loaded',
                      'funnel_iaa_load_failed',
                      'funnel_iaa_opportunitys',
                      'funnel_iaa_opportunity_ready',
                      'funnel_iaa_impressions',
                      'funnel_iaa_impression_failed',
                      'funnel_iaa_clicks',
                      'funnel_iaa_hidden',
                      'funnel_banner_imps_per_launch',
                      'funnel_opps_per_round',
                      'funnel_impression_per_level',
                    ],
                  },
                  config: {
                    props: {
                      config: {
                        otherParams: {
                          logical_flag: 'ad_format_all',
                        },
                        customFiltersConfig: {
                          customSelectorsDimensions: [
                            {
                              key: 'ad_format',
                              showSelector: true,
                              showColumn: true,
                              defaultValue: 'interstitial',
                              includeInAccumulation: true,
                              labelEn: 'Ad Format',
                              labelCn: '广告类型',
                              options: [
                                {
                                  value: '255',
                                  textEn: 'All',
                                  textCn: '全部',
                                  isAll: true,
                                },
                                {
                                  value: 'interstitial',
                                  textEn: 'Interstitial',
                                  textCn: '插屏广告',
                                },
                                {
                                  value: 'rewarded',
                                  textEn: 'Rewarded',
                                  textCn: '激励广告',
                                },
                                {
                                  value: 'banner',
                                  textEn: 'Banner',
                                  textCn: '横幅广告',
                                },
                              ],
                            },
                          ],
                        },
                        dimensionConfig: {
                          filterDimsAndColumns: ['ad_format'],
                        },
                        customColumnsAfterDim: [
                          {
                            columnKey: 'ad_format',
                            valueKey: 'ad_format',
                            nameEn: 'Ad Format',
                            nameCn: '广告类型',
                            enWidth: 146,
                            cnWidth: 120,
                            type: 'dimension',
                            align: 'left',
                            fixed: 'left',
                          },
                        ],
                        downConfig: {
                          requiredMetricCountToDownload: 1,
                        },
                      },
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
